<div class="the_container">
    <div class="d-flex justify-content-between mob-view">
        <span class="details-text">Mandir Bill Unsettled</span>
        <div class="filter-div">
            <div class="search-box">
                <img src="../../../../assets/images/search.svg" alt="" class="searchImg" (click)="getMandirByCode()">
                <input type="text" placeholder="Search by Mandir Code" [formControl]="searchCode">
            </div>
            <button class="buttonContent dp-primary-btn d-flex" (click)="onClickFilter()">
                filter <img src="../../../../assets/filter.svg" style="width: 15px; height: 15px;">
            </button>

        </div>
    </div>
    <div class="table-container">
        <table class="table">
            <thead class="table-head">
                <tr>
                    <th>
                        <span>Mandir Name</span>
                    </th>
                    <th>
                        <span>Mandir Code</span>
                    </th>
                    <th>
                        <span>State</span>
                    </th>
                    <th>
                        <span>District</span>
                    </th>
                    <th>
                        <span>Last Advance Date</span>
                    </th>
                    <th>
                        <span>Last Bill Receive Date</span>
                    </th>
                    <th>
                        <span>Advance Taken</span>
                    </th>
                    <th>
                        <span>Bill Details Provided</span>
                    </th>
                    <th>
                        <span>Bill Unsettled</span>
                    </th>
                    <th>
                        <span>Contact</span>
                    </th>

                </tr>
            </thead>
            <tbody class="table-body">
                @for(row of unSettledMandir;track row){
                <tr>
                    <td data-label="Mandir Name" >
                        <span>{{row.scoa_name}}</span>
                    </td>
                    <td data-label="Mandir Code">
                        <span>{{row.scoa_code}}</span>
                    </td>
                    <td data-label="State">
                        <span>{{row.state_name}}</span>
                    </td>
                    <td data-label="District">
                        <span>{{row.district_name}}</span>
                    </td>
                    <td data-label="Last Advance Date">
                        <span>{{row.last_advance_date}}</span>
                    </td>
                    <td data-label="Last Bill Receive Dat">
                        <span>{{row.last_bill_receive_date || '0'}}</span>
                    </td>
                    <td data-label="Advance Taken">
                        <span [class.clickable]="isValidAmount(row.total_advance_given)" (click)="isValidAmount(row.total_advance_given) && openAdvanceDetails(row)">{{formatIndianCurrency(row.total_advance_given)}}</span>
                    </td>
                    <td data-label="Bill Details Provided">
                        <span [class.clickable]="isValidAmount(row.total_bill_payment)" (click)="isValidAmount(row.total_bill_payment) && openBillDetails(row)">{{formatIndianCurrency(row.total_bill_payment)}}</span>
                    </td>
                    <td data-label="Bill Unsettled">
                        <span>{{formatIndianCurrency(row.remaining_amount)}}</span>
                    </td>
                    <td data-label="Contact">
                        <button type="button" class="dp-secondary-btn p-1" (click)="viewWorker(row.scoa_code)"> Contact </button>
                    </td>
                </tr>
                }
                @if (unSettledMandir.length===0) {
                    <tr>
                    <td data-label="emtyData">
                        <span> Data not found</span>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>